





































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {DialogRemove} from '@/helpers/dialog/DialogRemove'
import {AuditoriaMotivo} from '@/model/resource/AuditoriaMotivo'
import {AuditoriaMotivoCollection} from '@/model/collection/AuditoriaMotivoCollection'
import {ListAuditoriaMotivoSchema} from '@/schema/resource/AuditoriaMotivo/ListAuditoriaMotivoSchema'
import {CsvAuditoriaMotivoSchema} from '@/schema/resource/AuditoriaMotivo/CsvAuditoriaMotivoSchema'

@Component
export default class ListAuditoriaMotivoView extends Mixins(MixinQueryRouter) {
  schema = new ListAuditoriaMotivoSchema()
  collection = new AuditoriaMotivoCollection()

  async created() {
    this.collection.perPage = 20
    await this.query()
  }

  goToPersistView(item: AuditoriaMotivo) {
    Helper.pushByName('editAuditoriaMotivo', item.$id)
  }

  async removeItem(item: AuditoriaMotivo) {
    await new DialogRemove(item).confirm(() => item.removeAuditoriaMotivo())
    await this.collection.listAuditoriaMotivo()
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new AuditoriaMotivoCollection().clearFilters().addFilter(params)

    await csv.listCsvAuditoriaMotivo()
    new CsvAuditoriaMotivoSchema().downloadCsv(csv.all())
  }
}
